<style  lang="less" scoped>

.modal {
    /deep/.ivu-modal-body {
      max-height: 750px;
    }
    .special-item {
      margin-bottom: 5px;
    }
  }
</style>
<template>
  <div class="contain">
    <Modal
      v-model="showModal"
      class="modal"
      width="700"
      :closable="false"
      :title="modalTitle"
    >
      <Form
        ref="form"
        :model="formdata"
        :label-width="160"
      >
        <FormItem
          class="special-item"
          prop="parent_name"
          label="父级名称"
        >
          <span>
            <Select
              :value="formdata.parent_id"
              filterable
              allow-create
              @on-change="selectItem"
            >
              <Option
                v-for="item in sourceDataToList"
                :key="item.id"
                :style="{'padding-left': (item.level+1)*15+'px'}"
                :value="item.id"
                :disabled="item.edit_disabled"
              >
                {{ item.name }}
              </Option>
            </Select>

          </span>
          <!-- <span>{{ sourceDataToList }}</span>
          <span>
            {{ formdata.parent_name }}
          </span> -->
        </FormItem>
        <FormItem
          class="special-item"
          prop="parent_id"
          label="父级id"
        >
          <span>
            {{ formdata.parent_id }}
          </span>
        </FormItem>
        <FormItem
          v-show="'button'===formdata.route_type"
          prop="auth_key"
          label="key"
          :rules="{required: 'button'===formdata.route_type, message: 'key必填', trigger: 'blur'}"
        >
          <Input
            v-model="formdata.auth_key"
            placeholder="请输入名称"
          />
        </FormItem>
        <FormItem
          prop="name"
          label="名称"
          :rules="{required: true, message: '名称必填', trigger: 'blur'}"
        >
          <Input
            v-model="formdata.name"
            placeholder="请输入名称"
          />
        </FormItem>
        <FormItem
          prop="red_dot_token"
          label="红点提示"
        >
          <Input
            v-model="formdata.red_dot_token"
            placeholder="请输入红点提示"
          />
        </FormItem>
        <FormItem
          prop="icon"
          label="icon"
        >
          <Input
            v-model="formdata.icon"
            placeholder="请输入icon"
          />
        </FormItem>
        <Row>
          <i-col span="5">
            <FormItem
              prop="is_public"
              label="所有人可见"
            >
              <Checkbox v-model="formdata.is_public" />
            </FormItem>
          </i-col>
          <i-col span="5">
            <FormItem
              prop="is_formal"
              label="正式员工可见"
            >
              <Checkbox v-model="formdata.is_formal" />
            </FormItem>
          </i-col>
          <i-col span="5">
            <FormItem
              prop="is_team_leader"
              label="团队领导人可见"
            >
              <Checkbox v-model="formdata.is_team_leader" />
            </FormItem>
          </i-col>
        </Row>
        <FormItem
          prop="route_type"
          label="路由类型/权限类型"
          :rules="{required: true, message: '名称必填', trigger: 'blur'}"
        >
          <Select
            v-model="formdata.route_type"
            style="width:200px"
          >
            <Option
              v-for="item in router_type_list"
              :key="item.value"
              :value="item.value"
            >
              {{ item.label }}
            </Option>
          </Select>
        </FormItem>
        <FormItem
          v-if="show_path"
          prop="path"
          label="path"
          :rules="[
            { validator:validatorPath, trigger: 'blur'}
          ]"
        >
          <Select
            v-if="is_cur_app && 'api' !== formdata.route_type"
            v-model="formdata.path"
            filterable
          >
            <Option
              v-for="item in path_arr"
              :key="item.title"
              :value="item.val"
            >
              {{ item.title }}
            </Option>
          </Select>
          <i-input
            v-else
            v-model="formdata.path"
            placeholder="请输入路径"
          />
        </FormItem>
        <FormItem
          v-if="formdata.route_type==='powerbi'"
          prop="pb_workspace_id"
          label="pb_workspace_id"
          :rules="{required: true, message: 'pb_workspace_id必填', trigger: 'blur'}"
        >
          <Input
            v-model="formdata.pb_workspace_id"
            placeholder="请输入pb_workspace_id"
          />
        </FormItem>
        <FormItem
          v-if="formdata.route_type === 'powerbi'"
          prop="pb_report_id"
          label="pb_report_id"
          :rules="{required: true, message: 'pb_report_id必填', trigger: 'blur'}"
        >
          <Input
            v-model="formdata.pb_report_id"
            placeholder="请输入路径"
          />
        </FormItem>
        <FormItem
          v-if="show_url"
          prop="path"
          label="URL"
          :rules="[
            { required: true, message: 'URL必填', trigger: 'blur'},
            { validator: validatorURL, trigger: 'blur'}
          ]"
        >
          <Input
            v-model="formdata.path"
            autosize
            type="textarea"
            placeholder="请输入URL"
            @on-change="formatTableauUrl"
          />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button
          @click="cancel"
        >
          取消
        </Button>
        <Button
          type="primary"
          :loading="loading"
          @click="ok"
        >
          确定
        </Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import CONFIG from '../../../../config/config';
  import { FORM_ITEM_ROUTER } from './../constants'
  import { router_type } from './../fields'
  import { path_arr } from '../../../../router'
  import apiConfig from '../../../../api'
  import { submitData, pathTopology } from './../../utils'
  export default {
    props: {
      display: {
        type: Number,
        default:() => 0
      },
      formProps: {
        type:Object,
        default:() => ({})
      },
      loading:{
        type:Boolean,
        default:() => false
      },
      sourceData: {
        type:Array,
        default:() => []
      }
    },
    data() {
      this.router_hash = null
      this.parent_id = null
      this.path_arr = [{
        title:'无需path',
        val: 'NO_PATH'
      }].concat(path_arr.map(item => ({
        title: item,
        val: item
      })))
      this.path_dic = {}
      return {
        formdata: {...FORM_ITEM_ROUTER},
        modalTitle:'',
        showModal: false,
        // router_type_list: router_type
        tableau_attrs: {
          embed: {
            value: 'y',
            values: ['y', 'n']
          },
          toolbar: {
            value: 'n',
            values: ['y', 'n', 'top']
          },
          tabs: {
            value: 'y',
            values: ['y', 'n']
          },
        }
      }
    },
    computed: {
      is_cur_app() {
        return this.sourceData[0] && this.sourceData[0].app_token === CONFIG.app_token;
      },
      router_type_list() {
        return router_type
      },
      show_url() {
        return ['iframe', 'tableau', 'url-open'].includes(this.formdata.route_type);
      },
      show_path() {
        return !['iframe', 'tableau', 'url-open', 'powerbi'].includes(this.formdata.route_type);
      },
      sourceDataToList() {
        if (this.display === 0) {
          return []
        }
        const own_id = this.formProps.id
        const list = [
          {
            name:'根目录',
            auth_key: '',
            id:0,
            items: this.sourceData[0].items || []
          }
        ].reduce(function _reduce(total, item, index, source, parent_ids = [], level = 0) {
          let arr = []
          parent_ids.push(item.id)
          item.level = level
          if (own_id) {
            item.edit_disabled = parent_ids.includes(own_id)
          }
          if (!item.del) {
            arr.push(item)
          }
          if (!item.del && item.items && item.items.length) {
            arr = arr.concat(item.items.reduce((...other) => _reduce(...other, parent_ids, level + 1), []))
          }
          parent_ids.pop()
          return total.concat(arr)
        }, [])
        return list
      }
    },
    watch: {
      display(value) {
        if (value === 1) {
          const { parent_id, parent_name, parent_key } = this.formProps
          this.modalTitle = '新增'
          this.formdata = {...FORM_ITEM_ROUTER, parent_id, parent_name, parent_key}
        }
        if (value === 2) {
          this.router_hash = null
          this.modalTitle = '编辑'
          this.formdata = {...this.formProps}
          this.formdata.path = this.formdata.path || 'NO_PATH'
          this.parent_id = this.formdata.parent_id
        }
        if (value !== 0 && this.sourceData && this.sourceData[0]) {
          this.path_dic = pathTopology(this.sourceData[0].items)
        }
        if (value === 0) {
          this.showModal = false
          this.$refs.form.resetFields() // 清理form表单
        } else {
          this.showModal = true
        }
      }
    },
    created() {
      console.log(this.sourceData)
    },
    methods: {
      ok() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            let newParent = null
            let oldParent = null
            if (this.display === 2 && this.formdata.parent_id !== this.parent_id) {
              newParent = this.router_hash[this.formdata.parent_id]
              oldParent = this.router_hash[this.parent_id]
            }
            const _formdata = submitData(this.formdata)
            console.log('_formdata', _formdata)
            this.$emit('ok', { ..._formdata, newParent, oldParent })
          }
        })
      },
      cancel() {
        this.$emit('cancel')
      },
      // iframe url校验
      validatorURL(rule, value, callback) {
        // eslint-disable-next-line
              const http_regular = /(http|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/
        if (!http_regular.test(value)) {
          return callback(new Error('格式须为http(s)://xxx.xxx.xxx?xx=xx&xx=xx'));
        }
        callback()
      },
      validatorPath(rule, value, callback) {
        if ('api' === this.formdata.route_type) {
          callback()
          return
        }
        if (this.path_dic[value] && value !== this.formProps.path) {
          return callback(new Error(`在【${this.path_dic[value]}】中path已被选择`));
        }
        callback()
      },
      selectItem(data) {
        if (!this.router_hash) {
          const _this = this
          _this.router_hash = {}
          this.sourceDataToList.forEach(function _foreach(child) {
            _this.router_hash[child.id] = child
            if (child.items && child.items.length) {
              child.items.forEach(_foreach)
            }
          });
        }
        const item = this.router_hash[data]
        if (!item) return
        this.formdata.parent_id = data
        this.formdata.parent_key = item.auth_key
        this.formdata.parent_name = item.name
      },
      formatTableauUrl() {
        const { route_type, path } = this.formdata;
        if (route_type === 'tableau' && path && path.includes('http')) {
          const referer = path.replace(/\?\S+/, '');
          setTimeout(() => {
            this.formdata.path = `${referer}?:embed=y&:showAppBanner=false&:toolbar=false`;
          }, 500);
        }
      }
    }
  }
</script>
